const MARKER_TYPES = [
  'FrameMarker',
  'ArrowMarker',
  'FreehandMarker',
  'TextMarker',
  'CoverMarker'
];

function dataUrlToBlob(dataUrl) {
  return fetch(dataUrl).then((r) => r.blob());
}

export async function annotateImage(blob) {
  const markerjs2 = await import('markerjs2');
  const url = URL.createObjectURL(blob);

  return new Promise((resolve) => {
    const img = new Image();
    img.onload = () => {
      const host = document.createElement('div');
      host.setAttribute('data-issue-reporter', 'annotator');
      host.style.cssText = 'position: fixed; inset: 0; z-index: 9999;';
      host.appendChild(img);
      document.body.appendChild(host);

      const markerArea = new markerjs2.MarkerArea(img);
      markerArea.targetRoot = host;
      markerArea.availableMarkerTypes = MARKER_TYPES;
      markerArea.settings.displayMode = 'popup';
      markerArea.renderAtNaturalSize = true;
      markerArea.renderImageType = 'image/jpeg';
      markerArea.renderImageQuality = 0.85;

      let settled = false;
      const cleanup = () => {
        if (!settled) {
          settled = true;
          URL.revokeObjectURL(url);
          if (host.parentNode) host.parentNode.removeChild(host);
        }
      };

      let renderHandled = false;
      markerArea.addEventListener('render', async (event) => {
        renderHandled = true;
        try {
          if (!event || !event.dataUrl) throw new Error('render event missing dataUrl');
          const annotated = await dataUrlToBlob(event.dataUrl);
          cleanup();
          resolve(annotated);
        } catch {
          cleanup();
          resolve(blob);
        }
      });

      markerArea.addEventListener('close', () => {
        if (renderHandled) return;
        cleanup();
        resolve(null);
      });

      markerArea.show();
    };
    img.onerror = () => {
      URL.revokeObjectURL(url);
      resolve(null);
    };
    img.src = url;
  });
}
